import { Dispatch } from "redux";
import { resources } from "@constants/hardcoded-strings";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { setVerificationServiceDetailsLoading } from "@redux/actions/verification-service-details-actions";
import {
    getRpServiceChangeRequest,
    getVerificationServiceDetailsAxnAdminRequest,
    getVerificationServiceDetailsAxnRequest
} from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { datadogLogs } from '@datadog/browser-logs';
import { RpServiceChangeRequest } from "@idw-types/data/rp-service-change-request";

const getVerificationServiceDetailsFromAxn = async (rpServiceId: string, dispatch: Dispatch, serviceNotFoundCallback: () => void, showError: boolean): Promise<RpServiceConfiguration> => {
    const axnVerificationServiceDetailsResponse = await getVerificationServiceDetailsAxnRequest(rpServiceId);

    if (axnVerificationServiceDetailsResponse.data) {
        return axnVerificationServiceDetailsResponse.data;
    } else if (axnVerificationServiceDetailsResponse.error) {
        const errorCode = JSON.parse(axnVerificationServiceDetailsResponse.error).code;
        if (!showError && errorCode === 404) {
            serviceNotFoundCallback();
        } else {
            logAndDisplayErrorModal(
                dispatch,
                axnVerificationServiceDetailsResponse.error,
                resources.requests.getVerificationServiceDetails.error.title,
                resources.requests.getVerificationServiceDetails.error.message
            );
        }
    }
    return null;
};

export const getVerificationServiceDetailsReduxRequest = (dispatch: Dispatch) => async (
    rpServiceId: string,
    serviceNotFoundCallback: () => void,
    showError: boolean
): Promise<{
    verificationServiceDetails: RpServiceConfiguration;
    rpServiceChangeRequests: Array<RpServiceChangeRequest>;
}> => {
    dispatch(setVerificationServiceDetailsLoading(true));
    const rpServiceChangeRequest = await getRpServiceChangeRequest(rpServiceId);

    let verificationServiceDetails: RpServiceConfiguration;
    if (rpServiceChangeRequest.data?.rpServiceChangeRequests) {
        // check change requests - if one exists, attempt to get data from admin
        if (rpServiceChangeRequest.data.rpServiceChangeRequests.length > 0) {
            const axnAdminVerificationServiceDetailsResponse = await getVerificationServiceDetailsAxnAdminRequest(rpServiceId);
            // if admin data does not exist, attempt to get data from axn
            if (axnAdminVerificationServiceDetailsResponse.data) {
                verificationServiceDetails = axnAdminVerificationServiceDetailsResponse.data;
            } else {
                const errorMessage = `Service with ID ${rpServiceId} has a change request but is not present in AXN Admin`;
                console.error(errorMessage);
                datadogLogs.logger.error(errorMessage);

                verificationServiceDetails = await getVerificationServiceDetailsFromAxn(rpServiceId, dispatch, serviceNotFoundCallback, showError);
            }
        } else {
            // if no change requests exist, attempt to get data from axn
            verificationServiceDetails = await getVerificationServiceDetailsFromAxn(rpServiceId, dispatch, serviceNotFoundCallback, showError);
        }

    }

    if (verificationServiceDetails) {
        return {
            verificationServiceDetails,
            rpServiceChangeRequests: rpServiceChangeRequest.data?.rpServiceChangeRequests || []
        };
    } else {
        dispatch(setVerificationServiceDetailsLoading(false));
        return null;
    }
};